export const getChangeUser = (client, status, users) => {
  const userId = ((client.client_status || []).find(item => item.name === status.key) || {}).user_id
  if(!userId) {
    return ''
  }
  const user = users.find((user) => user.id === userId)
  if(!user) {
    return ''
  }
  return `${user.first_name} ${user.last_name}`
}
export const getChangeTime = (client, status) => {
  if(!((client.client_status || []).find(item => item.name === status.key) || {}).updated_at) {
    return ''
  }
  return ((client.client_status || []).find(item => item.name === status.key) || {}).updated_at
}
